// Function to generate section data
const getSectionData = (id, section, selector) => ({ id, section, selector });

// Check cart drawer and set sections to render
const cartDrawer = document.querySelector('cart-drawer');
let sectionsToRender = [];

if (cartDrawer) {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter"),
      getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")
    ];
  } else {
    sectionsToRender = [
      getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body"),
      getSectionData(".cart-drawer__title-counter", "cart-drawer", "#shopify-section-cart-drawer .cart-drawer__title-counter"),
      getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter")
    ];
  }
} else {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData('#cart-counter', 'cart-counter', '#shopify-section-cart-counter')
    ];
  } else {
    sectionsToRender = [];
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');

      if (this.dataset.lineId == window.theme.settings.shipping_protection_product_data.id) {
        setCookie('shipping_protection', 'removed', 1);
      }

      cartItems.updateQuantity(this.dataset.index, 0);
      updateFreeShipping();
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.freeShipping = document.querySelectorAll('shipping-bar');

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change', this.debouncedOnChange.bind(this)
    );

    updateFreeShipping();
  }

  calculateTotalItemCount(items) {
    return items.reduce((total, item) => total + item.quantity, 0);
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');
    let subItems = this.querySelector(`#CartItem-${line}`).querySelector('.cart-item__quantity').dataset.subIds
    const subItemsObj = {};

    if(subItems && subItems.length > 0){
      const itemsArray = Array.isArray(subItems) ? subItems : subItems.split(',');

      // Create object with each subItem as key and quantity as value
      itemsArray.forEach(item => {
        if (item && item.trim()) {
          subItemsObj[item.trim()] = parseInt(quantity, 10);
        }
      });

      const body = JSON.stringify({
        updates: subItemsObj,
        sections: this.getSectionsToRender().map(section => section.section),
        sections_url: window.location.pathname,
      });
      fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        ...{ body }
      })
        .then(response => response.text())
        .then(state => {
          updateAfterCartChange(state);
          if(document.querySelector('rewards-popup')) {
            document.querySelector('rewards-popup').updateCart(JSON.parse(state));
          }
        })
        .finally(() => this.classList.remove('is-loading'));
    }else{
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map(section => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        ...{ body }
      })
        .then(response => response.text())
        .then(state => {
          updateAfterCartChange(state);
          if(document.querySelector('rewards-popup')) {
            document.querySelector('rewards-popup').updateCart(JSON.parse(state));
          }
        })
        .finally(() => this.classList.remove('is-loading'));
    }
    const updateAfterCartChange = (state) => {
      const parsedState = JSON.parse(state);
      this.getSectionsToRender()?.forEach(section => {
        const elementToReplace = document.querySelector(section.selector) || document.querySelector(section.id);


        if (elementToReplace) {
          if (!parsedState.errors) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        } else {
          console.error(`Element with selector ${section.selector} not found`);
        }

      });
      if (!parsedState.errors) {
        this.totalItemCount = this.calculateTotalItemCount(parsedState.items);
      }
      this.updateLiveRegions(line, parsedState.item_count, parsedState.errors);

      const lineItem = document.getElementById(`CartItem-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`))
        lineItem.querySelector(`[name="${name}"]`).focus();

      updateFreeShipping();
      protectionProduct();
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount, parsedError) {
    if (parsedError) {
      document
        .querySelectorAll(`[data-line-item-error][data-line="${line}"]`)
        .forEach(error => {
          error.innerHTML = parsedError;
        });
    }

    this.currentItemCount = itemCount;
  }
}
customElements.define('cart-items', CartItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", event => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.setCartLink();
    this.parentElement.addEventListener("shopify:section:select", () => this.open());
    this.parentElement.addEventListener("shopify:section:deselect", () => this.close());
  }

  setCartLink() {
    const cartLink = document.querySelector("[data-cart-link]");
    if (cartLink) {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", event => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", event => {
        if (event.code.toUpperCase() !== "SPACE") return;
        event.preventDefault();
        this.open(cartLink);
      });
    } else {
      console.error("Cart link not found");
    }
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add("is-visible");
    document.querySelector('body').style.overflow = 'hidden';
    this.addEventListener("transitionend", () => { this.focusOnCartDrawer(); }, { once: true });

    setTimeout(() => {
      document.addEventListener("click", this.handleOutsideClick);
    }, 100);

    const productReccomendations = document.querySelector(".product-recommendations");
    if (productReccomendations) {
      if (productReccomendations.classList.contains("hidden")) {
        document.querySelector(".cart-drawer-items").classList.add("cart-drawer-items__full");
      } else {
        document.querySelector(".cart-drawer-items").classList.remove("cart-drawer-items__full");
      }
    }
  }

  close() {
    this.classList.remove("is-visible");
    document.querySelector('body').style.overflow = '';
    document.querySelector('body').style.overflowX = 'hidden';
    removeTrapFocus(this.activeElement);

    document.removeEventListener("click", this.handleOutsideClick);

    const isHeaderMenuOpen = header.classList.contains("menu-open");

    if (isHeaderMenuOpen) {
      return;
    }

    // if we are on the cart page, resubmit form
    if (window.location.pathname === "/cart") {
      const cartDrawerForm = document.getElementById("CartDrawer-FormSummary");
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  handleOutsideClick = event => {
    const cartDrawerInner = this.querySelector(".cart-drawer__inner");

    const clickedElement = event.target;
    const isOmnisendClick = 
      clickedElement.closest('#omnisend-forms-wrapper') ||
      clickedElement.closest('[class*="omnisend-"]') ||
      clickedElement.closest('[id*="omnisend-"]');
    const isColourDrawerOpen = !!this.querySelector('colour-drawer details[open]');
    const isUpsellOpen = !!document.querySelector('cart-upsell details[open]');

    if (
      cartDrawerInner &&
      !cartDrawerInner.contains(event.target) &&
      !isOmnisendClick &&
      !isColourDrawerOpen &&
      !isUpsellOpen
    ) {
      this.close();
    } else if (isColourDrawerOpen && !this.querySelector('colour-drawer:has(details[open])')?.contains(clickedElement)) {
      this.querySelector('colour-drawer:has(details[open])')?.btnsCloseDrawer?.[0]?.click();
    } else if (isUpsellOpen && !document.querySelector('cart-upsell:has(details[open])')?.contains(clickedElement)) {
      document.querySelector('cart-upsell:has(details[open])')?.close(event, false);
    }
  };

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector("[data-drawer-close]");
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response, open = true) {
    if(document.querySelector('rewards-popup')) {
      document.querySelector('rewards-popup').updateCart(response);
    }
    protectionProduct();
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );

      updateCartCounters();
    });
    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);

window.subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
  let cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.renderContents(data.cartData);
  }  
});

let updatingprotectionProduct = false;

async function protectionProduct() {
  if (!window.theme.settings.shipping_protection_enabled) return;
  if (updatingprotectionProduct) return;
  if (getCookie('shipping_protection') === 'removed') return;
  const productId = window.theme.settings.shipping_protection_product_data.id;

  updatingprotectionProduct = true;

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const hasProtectionProduct = cart.items.some(item => item.id === productId);
      const protectionProduct = cart.items.find(item => item.id === productId);

      if (cart.items.length == 0 || (cart.items.length > 1 && protectionProduct?.quantity > 1)) {
        updatingprotectionProduct = false;
        return;
      }

      if (!hasProtectionProduct && cart.items.length > 0) {
        const body = JSON.stringify({
          items: [{
            id: productId,
            quantity: 1
          }],
          sections: ['cart-drawer', 'cart-counter', 'main-cart-items'],
          sections_url: window.location.pathname
        });
        fetch('/cart/add.js', {
          ...fetchConfig(),
          ...{ body }
        })
          .then(response => response.text())
          .then(state => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.renderContents(JSON.parse(state), false);
            }
            updatingprotectionProduct = false;
            updateCartCounters();
          });
      } else if (hasProtectionProduct && cart.items.length === 1) {
        const body = JSON.stringify({
          updates: { [productId]: 0 },
          sections: ['cart-drawer', 'cart-counter', 'main-cart-items'],
          sections_url: window.location.pathname
        });
        fetch('/cart/update.js', {
          ...fetchConfig(),
          ...{ body }
        })
          .then(response => response.text())
          .then(state => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              cartDrawer.renderContents(JSON.parse(state), false);
            }
            updatingprotectionProduct = false;
            updateCartCounters();
          });
      } else {
        updatingprotectionProduct = false;
        updateCartCounters();
      }
    });
}